// src/Redux/reducer/globalDataSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Activity, GroupedActivity } from "../../lib/types";
import { groupActivitiesByGroup } from "../../lib/bookingMappers";

export interface Report {
  pdfBase64: string;
  episodeId: string;
  registrationDate: string;
  withdrawalDate: string;
  typeId: string;
  Name: string;
  workareasString?: string;
  examinationState?: number;
}

interface GlobalDataState {
  globalReports: Report[];                // i referti
  globalActivities: Activity[];           // le prestazioni
  groupedActivities: GroupedActivity[];   // prestazioni raggruppate per categoria
  isActivitiesLoaded: boolean;            // flag per capire se abbiamo già caricato
  activitiesLoading: boolean;             // flag caricamento activities
  reportsLoading: boolean;                // flag di "caricamento referti"
}

const initialState: GlobalDataState = {
  globalReports: [],
  globalActivities: [],
  groupedActivities: [],
  isActivitiesLoaded: false,
  activitiesLoading: false,
  reportsLoading: false,
};

export const globalDataSlice = createSlice({
  name: "globalData",
  initialState,
  reducers: {
    // Imposta i referti
    setGlobalReports: (state, action: PayloadAction<Report[]>) => {
      state.globalReports = action.payload;
    },
    // Imposta le prestazioni
    setGlobalActivities: (state, action: PayloadAction<Activity[]>) => {
      state.globalActivities = action.payload;
      state.groupedActivities = groupActivitiesByGroup(action.payload);
      state.isActivitiesLoaded = true;
      state.activitiesLoading = false;
    },
    // Flag loading activities
    setActivitiesLoading: (state, action: PayloadAction<boolean>) => {
      state.activitiesLoading = action.payload;
    },
    // Flag loading referti
    setGlobalReportsLoading: (state, action: PayloadAction<boolean>) => {
      state.reportsLoading = action.payload;
    },
    // Reset completo dello stato (per logout)
    resetGlobalData: (state) => {
      state.globalReports = [];
      state.globalActivities = [];
      state.groupedActivities = [];
      state.isActivitiesLoaded = false;
      state.activitiesLoading = false;
      state.reportsLoading = false;
    },
  },
});

export const {
  setGlobalReports,
  setGlobalActivities,
  setActivitiesLoading,
  setGlobalReportsLoading,
  resetGlobalData,
} = globalDataSlice.actions;

export default globalDataSlice.reducer;
